import { render, staticRenderFns } from "./CitationItem.vue?vue&type=template&id=3f176e4a"
import script from "./CitationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CitationItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CitationItem.vue?vue&type=style&index=0&id=3f176e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports